var instantAnimationState = {
    current: false,
};

export { instantAnimationState };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/use-instant-transition-state.mjs
// module id = cwjR
// module chunks = 0